import { render, staticRenderFns } from "./ChineseDivider.vue?vue&type=template&id=2deec987&scoped=true"
import script from "./ChineseDivider.vue?vue&type=script&lang=js"
export * from "./ChineseDivider.vue?vue&type=script&lang=js"
import style0 from "./ChineseDivider.vue?vue&type=style&index=0&id=2deec987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deec987",
  null
  
)

export default component.exports